function prettyPriceFilter($translate, $filter) {
    'ngInject';

    return function (price, currency_code) {
        if (parseFloat(price) === 0) {
            return $translate.instant('CORE.FILTERS.PRETTY_PRICE.FREE');
        } else {
            return $filter('currency')(price, currency_code, true);
        }
    };
}

angular
    .module('BB')
    .filter('pretty_price', prettyPriceFilter);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/pretty_price.filter.js